import { RouteLocationNormalized } from 'vue-router'

import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { Room } from '@/shared/types/store'

export const prepareToCallPropsFn  = (to: RouteLocationNormalized): {
  room: Room
} => {
  const roomId = to.params.roomId as string
  const room = useStoreRooms().getRoomById(roomId)
  if (!room) {
    throw new Error('No room found')
  }
  return {
    room,
  }
}
